// src/js/modules/copy-link.js
function fallbackCopyTextToClipboard(text) {
  let textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    let successfulCopy = document.execCommand("copy");
    if (successfulCopy) {
      alert("Copied to clipboard: " + text);
    } else {
      alert("Unable to copy");
    }
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
    alert("Fallback: Unable to copy");
  }
  document.body.removeChild(textArea);
}
document.querySelector(".copy-link")?.addEventListener("click", function(event) {
  event.preventDefault();
  const linkToCopy = this.getAttribute("data-link");
  if (linkToCopy) {
    fallbackCopyTextToClipboard(linkToCopy);
  }
});
